import React from 'react';

import Button from 'components/form/Button.component';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import useTip from 'hooks/useTip.hook';
import { fromEventToValue } from 'utils/converters/event.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import { fromPropsToMatchedSalonId } from 'utils/converters/props/bl.util';
import logger from 'utils/logger.util';

import CheckoutVoucherV2 from 'checkout/components/voucher/CheckoutVoucher.component';

import CN from './VoucherPage.module.scss';

const L = logger('VoucherPage');

const VoucherPage = (props) => {
  const salonId = fromPropsToMatchedSalonId(props);

  const [clientId, setClientId] = useStateWhileMounted(59442);
  const [total, setTotal] = useStateWhileMounted(65);

  const handleClientChange = (ev) => setClientId(fromAnyToInteger(fromEventToValue(ev)));
  const handleTotalChange = (ev) => setTotal(fromAnyToNumber(fromEventToValue(ev)));
  const { val: isVoucherRendered, tip: toggle } = useTip(true);

  L.debug('()', { salonId, total, clientId }, props);

  return (
    <div data-bem="VoucherPage" className={CN.component}>
      <div className={CN.horizontal}>
        <label>
          clientId: <input value={clientId} onChange={handleClientChange} />
        </label>

        <label>
          total: <input value={total} onChange={handleTotalChange} />
        </label>
      </div>

      <div className={CN.horizontal}>
        <Button onClick={toggle}>Toggle</Button>
        <p>
          Because the <code>CheckoutVoucherV2</code> component has internal state, you might need to toggle it off then on before it accepts the new <code>total</code> and <code>clientId</code> values
        </p>
      </div>

      {isVoucherRendered && <CheckoutVoucherV2 total={total} clientId={clientId} />}
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default VoucherPage;
